import React from "react";
import { Link } from "react-navi";
import styles from "./NotFoundPage.module.css";

function NotFoundPage() {
  return (
    <div className={styles.NotFound}>
      <div className={styles.card}>
        <span className={styles.code}>404</span>
        <h1>Page not found</h1>
        <p>
          The page you&apos;re looking for doesn&apos;t exist or may have been
          moved.
        </p>
        <Link className={styles.homeLink} href="/">
          Back to blog home
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
